/** Every sound effect by name (04 §5). Pure. */

import type { SoundId } from '../scan';
import type { UiSound } from '../types';
import { beamOff, beamOn, captured, caught, docked, rescued } from './beam';
import {
  empressBlast, empressHit, empressKilled, empressPhase, lanceEnd, lanceFire, lanceWarn, warning,
} from './empress';
import { extraLife, fire, playerDied, ready } from './fighter';
import { bomb, captiveKilled, dive, enemyHit, kill, morph, morphBonus, waveBonus } from './hive';
import type { Sfx } from './kit';
import { capsule, chain, nova, powerDown, powerUp, shieldBurst } from './nova';
import { badge, challenge, gameOver, perfect, tally } from './stage';
import * as ui from './ui';

export type { Sfx } from './kit';
export { BEAM_CENTS, BEAM_HZ, BEAM_RATE, checkDrone, DRONES, type DroneSpec } from './ambient';
export { DIVE_HZ, KILL_HZ } from './hive';
export { chainMidi } from './nova';
export { tallyBlips } from './stage';

export const SFX: Readonly<Record<SoundId, Sfx>> = {
  fire, playerDied, ready, extraLife,
  enemyHit, kill, captiveKilled, dive, bomb, morph, waveBonus, morphBonus,
  beamOn, beamOff, caught, captured, rescued, docked,
  badge, challenge, tally, perfect, gameOver,
  capsule, powerUp, powerDown, shieldBurst, nova, chain,
  warning, empressHit, empressPhase, empressBlast, empressKilled, lanceWarn, lanceFire, lanceEnd,
};

export const UI_SFX: Readonly<Record<UiSound, Sfx>> = {
  move: ui.move, select: ui.select, back: ui.back, error: ui.error, type: ui.type,
};
